<div class="flex justify-end py-3">
  <a
    *ngIf="filing?.sourceLink"
    [href]="filing.sourceLink"
    target="_blank"
    class="text-[#002644] hover:text-[#002644] flex items-center gap-2 mr-5 transition-all duration-200"
    pTooltip="View Source File"
    tooltipPosition="top"
  >
    <i class="pi pi-link text-lg"></i>
    <span class="underline hover:no-underline font-medium">View Source</span>
  </a>
</div>
<!-- Table Headers -->
<p-table
  [value]="[filing.asReportedIssuer]"
  [paginator]="false"
  [rows]="5"
  [first]="first"
  [showCurrentPageReport]="true"
  [tableStyle]="{ 'min-width': '50rem' }"
  currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
  [rowsPerPageOptions]="[5, 10, 25, 50]"
>
  <ng-template #header>
    <tr>
      <th>Issuer Name</th>
      <th>CIK</th>
      <th>EIN</th>
      <th>SIC</th>
      <th>STATE OF INCORPORATION</th>
      <th>FILE NUMBER</th>
      <th>YEAR END</th>
    </tr>
  </ng-template>
  <ng-template #body let-issuer>
    <tr>
      <td>
        {{ issuer.asReportedIssuerName }}
      </td>
      <td>{{ issuer.asReportedCik }}</td>
      <td>{{ issuer.asReportedEin }}</td>
      <td>
        {{ issuer.asReportedSic }}
      </td>
      <td>{{ issuer.asReportedStateOfIncorporation }}</td>
      <td>{{ issuer.asReportedFileNumber }}</td>
      <td>{{ issuer.asReportedFiscalYearEnd }}</td>
    </tr>
  </ng-template>
</p-table>
<div class="flex justify-end my-6">
  <button
    pButton
    type="button"
    label="Add New Plan"
    (click)="addTradingPlan()"
    class=""
  ></button>
</div>
<!-- Main Form Group -->
<div [formGroup]="formMainGroup">
  <!-- Trading Plans Form Array -->
  <div formArrayName="tradingPlans">
    <!-- Trading Plan Form Groups -->
    <div
      *ngFor="let plan of tradingPlans.controls; let i = index"
      [formGroupName]="i"
      class="my-6 relative"
    >
      <button
        *ngIf="tradingPlans.length > 1 && i !== 0"
        type="button"
        (click)="removeTradingPlan(i)"
        class="absolute my-2 top-0 right-0 m-2 w-6 h-6 flex items-center justify-center text-red-500 hover:text-white hover:bg-red-500 border border-red-500 rounded-full text-sm cursor-pointer transition duration-200"
        title="Remove Trading Plan"
      >
        ✕
      </button>
      <div class="border border-gray-200 rounded-xl shadow p-6 bg-white">
        <h3 class="text-lg font-medium my-4">Trading Plans</h3>
        <div
          class="grid gap-6 grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5"
        >
          <!-- Insider Name -->
          <div class="relative z-0 w-full mb-5 group">
            <input
              formControlName="insiderName"
              [ngClass]="{ 'border-red-500': isFieldInvalid(i, 'insiderName') }"
              type="text"
              [id]="'insiderName' + i"
              class="block py-2.5 px-0 w-full text-sm text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 appearance-none focus:outline-none focus:ring-0 focus:border-[#1f273b] peer"
              placeholder=" "
            />
            <label
              [for]="'insiderName' + i"
              class="peer-focus:font-medium absolute text-sm text-gray-500 duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:text-[#1f273b] peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6"
            >
              Insider Name
            </label>
            <small
              *ngIf="isFieldInvalid(i, 'insiderName')"
              class="text-red-500"
            >
              {{ getErrorMessage(i, "insiderName") }}
            </small>
          </div>
          <!-- Reporting Entity Name -->
          <div class="relative z-0 w-full mb-5 group">
            <input
              formControlName="asReportedReportingEntityName"
              [ngClass]="{
                'border-red-500': isFieldInvalid(
                  i,
                  'asReportedReportingEntityName'
                )
              }"
              type="text"
              [id]="'asReportedReportingEntityName' + i"
              class="block py-2.5 px-0 w-full text-sm text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 appearance-none focus:outline-none focus:ring-0 focus:border-[#1f273b] peer"
              placeholder=" "
            />
            <label
              [for]="'asReportedReportingEntityName' + i"
              class="peer-focus:font-medium absolute text-sm text-gray-500 duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:text-[#1f273b] peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6"
            >
              Reporting Entity Name
            </label>
            <small
              *ngIf="isFieldInvalid(i, 'asReportedReportingEntityName')"
              class="text-red-500"
            >
              {{ getErrorMessage(i, "asReportedReportingEntityName") }}
            </small>
          </div>

          <!-- Reporting Entity Type -->
          <div class="relative w-full mb-5 group">
            <p-dropdown
              [options]="entityTypeOptions"
              optionLabel="label"
              optionValue="value"
              [panelStyleClass]="'z-[9999]'"
              formControlName="asReportedReportingEntityType"
              [inputId]="'asReportedReportingEntityType' + i"
              placeholder="Select Reporting Entity Type"
              [style]="{
                border: 'none',
                paddingLeft: '0px',
                paddingRight: '0px',
                width: '100%',
                fontSize: '0.875rem',
                color: '#111827',
                borderBottom: '2px solid #d1d5db',
                boxShadow: 'none',
                borderRadius: '0',
                outline: 'none',
                paddingTop: '9px',
                paddingBottom: '9px'
              }"
              [ngClass]="{
                'border-red-500': isFieldInvalid(
                  i,
                  'asReportedReportingEntityType'
                )
              }"
            ></p-dropdown>
            <label
              [for]="'asReportedReportingEntityType' + i"
              class="peer-focus:font-medium absolute left-0 text-sm text-gray-500 duration-300 transform -translate-y-6 scale-75 top-3 origin-[0] peer-focus:text-[#1f273b] peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6"
            >
              Reporting Entity Type
            </label>
            <small
              *ngIf="isFieldInvalid(i, 'asReportedReportingEntityType')"
              class="text-red-500"
            >
              {{ getErrorMessage(i, "asReportedReportingEntityType") }}
            </small>
          </div>

          <!-- Insider Role in Entity-->
          <div class="relative z-0 w-full mb-5 group">
            <input
              formControlName="asReportedInsiderRoleInEntity"
              [ngClass]="{
                'border-red-500': isFieldInvalid(
                  i,
                  'asReportedInsiderRoleInEntity'
                )
              }"
              type="text"
              [id]="'asReportedInsiderRoleInEntity' + i"
              class="block py-2.5 px-0 w-full text-sm text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 appearance-none focus:outline-none focus:ring-0 focus:border-[#1f273b] peer"
              placeholder=" "
            />
            <label
              [for]="'asReportedInsiderRoleInEntity' + i"
              class="peer-focus:font-medium absolute text-sm text-gray-500 duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:text-[#1f273b] peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6"
            >
              Insider Role in Entity
            </label>
            <small
              *ngIf="isFieldInvalid(i, 'asReportedInsiderRoleInEntity')"
              class="text-red-500"
            >
              {{ getErrorMessage(i, "asReportedInsiderRoleInEntity") }}
            </small>
          </div>

          <!-- Relation -->
          <div class="relative z-0 w-full mb-5 group">
            <input
              formControlName="relation"
              [ngClass]="{ 'border-red-500': isFieldInvalid(i, 'relation') }"
              type="text"
              [id]="'relation' + i"
              class="block py-2.5 px-0 w-full text-sm text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 appearance-none focus:outline-none focus:ring-0 focus:border-[#1f273b] peer"
              placeholder=" "
            />
            <label
              [for]="'relation' + i"
              class="peer-focus:font-medium absolute text-sm text-gray-500 duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:text-[#1f273b] peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6"
            >
              Relation
            </label>
            <small *ngIf="isFieldInvalid(i, 'relation')" class="text-red-500">
              {{ getErrorMessage(i, "relation") }}
            </small>
          </div>

          <!-- Plan Action -->
          <div class="relative w-full mb-5 group">
            <p-dropdown
              [options]="planActionOptions"
              optionLabel="label"
              optionValue="value"
              [panelStyleClass]="'z-[9999]'"
              formControlName="planAction"
              [inputId]="'planAction' + i"
              placeholder="Select Plan Action"
              [style]="{
                border: 'none',
                paddingLeft: '0px',
                paddingRight: '0px',
                width: '100%',
                fontSize: '0.875rem',
                color: '#111827',
                borderBottom: '2px solid #d1d5db',
                boxShadow: 'none',
                borderRadius: '0',
                outline: 'none',
                paddingTop: '9px',
                paddingBottom: '9px'
              }"
              [ngClass]="{
                'border-red-500': isFieldInvalid(i, 'planAction')
              }"
            ></p-dropdown>
            <label
              [for]="'planAction' + i"
              class="peer-focus:font-medium absolute left-0 text-sm text-gray-500 duration-300 transform -translate-y-6 scale-75 top-3 origin-[0] peer-focus:text-[#1f273b] peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6"
            >
              Plan Action
            </label>
            <small *ngIf="isFieldInvalid(i, 'planAction')" class="text-red-500">
              {{ getErrorMessage(i, "planAction") }}
            </small>
          </div>
          <!-- Adoption Date -->
          <div class="relative w-full mb-5 group">
            <p-datepicker
              formControlName="adoptionDate"
              [showIcon]="true"
              [iconDisplay]="'input'"
              [id]="'adoptionDate' + i"
              [placeholder]="'yy/mm/dd'"
              dateFormat="yy/mm/dd"
              [showClear]="true"
              [panelStyleClass]="'z-[9999]'"
              clearButtonStyleClass="bg-red right-4 ml-6 text-red"
              [inputStyle]="{
                border: 'none',
                paddingLeft: '0',
                paddingRight: '0'
              }"
              [styleClass]="
                'peer block px-0 pr-10 w-full text-sm text-gray-900  appearance-none border-0 border-b-2 focus:outline-none focus:ring-0 ' +
                (isFieldInvalid(i, 'adoptionDate')
                  ? 'border-red-500'
                  : 'border-gray-300 focus:border-[#1f273b]')
              "
            />

            <label
              [for]="'adoptionDate' + i"
              class="peer-focus:font-medium absolute left-0 text-sm text-gray-500 duration-300 transform -translate-y-6 scale-75 top-3 origin-[0] peer-focus:text-[#1f273b] peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6"
            >
              Adoption Date
            </label>
            <small
              *ngIf="isFieldInvalid(i, 'adoptionDate')"
              class="text-red-500"
            >
              {{ getErrorMessage(i, "adoptionDate") }}
            </small>
          </div>

          <!-- Effective Date -->
          <div class="relative w-full mb-5 group">
            <p-datepicker
              formControlName="effectiveDate"
              [showIcon]="true"
              [iconDisplay]="'input'"
              [id]="'effectiveDate' + i"
              [placeholder]="'yy/mm/dd'"
              dateFormat="yy/mm/dd"
              [showClear]="true"
              [panelStyleClass]="'z-[9999]'"
              clearButtonStyleClass="bg-red right-4 ml-6 text-red"
              [inputStyle]="{
                border: 'none',
                paddingLeft: '0',
                paddingRight: '0'
              }"
              [styleClass]="
                'peer block px-0 pr-10 w-full text-sm text-gray-900  appearance-none border-0 border-b-2 focus:outline-none focus:ring-0 ' +
                (isFieldInvalid(i, 'effectiveDate')
                  ? 'border-red-500'
                  : 'border-gray-300 focus:border-[#1f273b]')
              "
            />

            <label
              [for]="'effectiveDate' + i"
              class="peer-focus:font-medium absolute left-0 text-sm text-gray-500 duration-300 transform -translate-y-6 scale-75 top-3 origin-[0] peer-focus:text-[#1f273b] peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6"
            >
              Effective Date
            </label>
            <small
              *ngIf="isFieldInvalid(i, 'effectiveDate')"
              class="text-red-500"
            >
              {{ getErrorMessage(i, "effectiveDate") }}
            </small>
          </div>
          <!-- Amendment Date -->
          <div class="relative w-full mb-5 group">
            <p-datepicker
              formControlName="amendmentDate"
              [showIcon]="true"
              [iconDisplay]="'input'"
              [id]="'amendmentDate' + i"
              [placeholder]="'yy/mm/dd'"
              dateFormat="yy/mm/dd"
              [showClear]="true"
              [panelStyleClass]="'z-[9999]'"
              clearButtonStyleClass="bg-red right-4 ml-6 text-red"
              [inputStyle]="{
                border: 'none',
                paddingLeft: '0',
                paddingRight: '0'
              }"
              [styleClass]="
                'peer block px-0 pr-10 w-full text-sm text-gray-900  appearance-none border-0 border-b-2 focus:outline-none focus:ring-0 ' +
                (isFieldInvalid(i, 'amendmentDate')
                  ? 'border-red-500'
                  : 'border-gray-300 focus:border-[#1f273b]')
              "
            />

            <label
              [for]="'amendmentDate' + i"
              class="peer-focus:font-medium absolute left-0 text-sm text-gray-500 duration-300 transform -translate-y-6 scale-75 top-3 origin-[0] peer-focus:text-[#1f273b] peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6"
            >
              Amendment Date
            </label>
            <small
              *ngIf="isFieldInvalid(i, 'amendmentDate')"
              class="text-red-500"
            >
              {{ getErrorMessage(i, "amendmentDate") }}
            </small>
          </div>

          <!-- Termination Date -->
          <div class="relative w-full mb-5 group">
            <p-datepicker
              formControlName="terminationDate"
              [showIcon]="true"
              [iconDisplay]="'input'"
              [id]="'terminationDate' + i"
              [placeholder]="'yy/mm/dd'"
              dateFormat="yy/mm/dd"
              [showClear]="true"
              [panelStyleClass]="'z-[9999]'"
              clearButtonStyleClass="bg-red right-4 ml-6 text-red"
              [inputStyle]="{
                border: 'none',
                paddingLeft: '0',
                paddingRight: '0'
              }"
              [styleClass]="
                'peer block px-0 pr-10 w-full text-sm text-gray-900  appearance-none border-0 border-b-2 focus:outline-none focus:ring-0 ' +
                (isFieldInvalid(i, 'terminationDate')
                  ? 'border-red-500'
                  : 'border-gray-300 focus:border-[#1f273b]')
              "
            />

            <label
              [for]="'terminationDate' + i"
              class="peer-focus:font-medium absolute left-0 text-sm text-gray-500 duration-300 transform -translate-y-6 scale-75 top-3 origin-[0] peer-focus:text-[#1f273b] peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6"
            >
              Termination Date
            </label>
            <small
              *ngIf="isFieldInvalid(i, 'terminationDate')"
              class="text-red-500"
            >
              {{ getErrorMessage(i, "terminationDate") }}
            </small>
          </div>

          <!-- Expiration Date -->
          <div class="relative w-full mb-5 group">
            <p-datepicker
              formControlName="expirationDate"
              [showIcon]="true"
              [iconDisplay]="'input'"
              [id]="'expirationDate' + i"
              [placeholder]="'yy/mm/dd'"
              dateFormat="yy/mm/dd"
              [showClear]="true"
              [panelStyleClass]="'z-[9999]'"
              clearButtonStyleClass="bg-red right-4 ml-6 text-red"
              [inputStyle]="{
                border: 'none',
                paddingLeft: '0',
                paddingRight: '0'
              }"
              [styleClass]="
                'peer block px-0 pr-10 w-full text-sm text-gray-900  appearance-none border-0 border-b-2 focus:outline-none focus:ring-0 ' +
                (isFieldInvalid(i, 'expirationDate')
                  ? 'border-red-500'
                  : 'border-gray-300 focus:border-[#1f273b]')
              "
            />

            <label
              [for]="'expirationDate' + i"
              class="peer-focus:font-medium absolute left-0 text-sm text-gray-500 duration-300 transform -translate-y-6 scale-75 top-3 origin-[0] peer-focus:text-[#1f273b] peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6"
            >
              Expiration Date
            </label>
          </div>

          <!-- Duration Days -->
          <div class="relative z-0 w-full mb-5 group">
            <input
              formControlName="durationDays"
              [ngClass]="{
                'border-red-500': isFieldInvalid(i, 'durationDays')
              }"
              type="number"
              [id]="'durationDays' + i"
              class="block py-2.5 px-0 w-full text-sm text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 appearance-none focus:outline-none focus:ring-0 focus:border-[#1f273b] peer"
              placeholder=" "
            />
            <label
              [for]="'durationDays' + i"
              class="peer-focus:font-medium absolute text-sm text-gray-500 duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:text-[#1f273b] peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6"
            >
              Duration Days
            </label>
            <small
              *ngIf="isFieldInvalid(i, 'durationDays')"
              class="text-red-500"
            >
              {{ getErrorMessage(i, "durationDays") }}
            </small>
          </div>
          <!-- Plan Text -->
          <div class="relative z-0 w-full mb-5 group">
            <textarea
              formControlName="asReportedPlanText"
              [ngClass]="{
                'border-red-500': isFieldInvalid(i, 'asReportedPlanText')
              }"
              rows="1"
              [id]="'asReportedPlanText' + i"
              class="block py-2.5 px-0 w-full text-sm text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 appearance-none focus:outline-none focus:ring-0 focus:border-[#1f273b] peer"
              placeholder=" "
            ></textarea>
            <label
              [for]="'asReportedPlanText' + i"
              class="peer-focus:font-medium absolute text-sm text-gray-500 duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:text-[#1f273b] peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6"
            >
              Plan Text
            </label>
            <small
              *ngIf="isFieldInvalid(i, 'asReportedPlanText')"
              class="text-red-500"
            >
              {{ getErrorMessage(i, "asReportedPlanText") }}
            </small>
          </div>

            <!-- Insider Comment -->
          <div class="relative z-0 w-full mb-5 group"  *ngIf="tradingPlans.at(i).get('insiderId')?.value">
            <textarea
              formControlName="insiderComment"
             
              rows="1"
              [id]="'insiderComment' + i"
              class="block py-2.5 px-0 w-full text-sm text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 appearance-none focus:outline-none focus:ring-0 focus:border-[#1f273b] peer"
              placeholder=" "
            ></textarea>
            <label
              [for]="'insiderComment' + i"
              class="peer-focus:font-medium absolute text-sm text-gray-500 duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:text-[#1f273b] peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6"
            >
             Insider Comment
            </label>
            
          </div>
          <!-- Manage Tags -->
           <div class="button-group  items-center mt-1">
                <button
                  (click)="AddPlanTags(i)"
                  class="flex items-center cursor-pointer gap-2 py-2 px-4 border border-[#d1d5db] rounded-lg bg-white text-gray-700 hover:bg-[#1f273b] hover:text-white transition-all duration-200 shadow-sm hover:shadow-md focus:outline-none"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    class="w-4 h-4"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M7 7h.01M5 11a1 1 0 011-1h.01M11 5h2m2 2h.01M13 13h3l2-2m0 0l2 2m-2-2v6a2 2 0 01-2 2H7a2 2 0 01-2-2v-3"
                    />
                  </svg>
                  <span class="text-sm font-medium">Manage Tags</span>
                </button>
              </div>
        </div>

        <!-- Security Breakdowns -->
        <div class="flex justify-between my-4 items-center">
          <h4 class="text-lg font-medium mt-2">Security Breakdowns</h4>
          <button
            pButton
            type="button"
            label="New Breakdown"
            (click)="addSecurityBreakdown(i)"
            class=""
          ></button>
        </div>

        <div formArrayName="securityBreakdowns">
          <div
            *ngFor="
              let breakdown of getBreakdownControls(i).controls;
              let j = index
            "
            [formGroupName]="j"
          >
            <div
              class="grid gap-6 grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 my-4 relative border border-gray-200 p-6 rounded-xl shadow"
            >
              <button
                type="button"
                (click)="removeSecurityBreakdown(i, j)"
                class="absolute my-2 top-0 right-0 m-2 w-6 h-6 flex items-center justify-center text-red-500 hover:text-white hover:bg-red-500 border border-red-500 rounded-full text-sm cursor-pointer transition duration-200"
                title="Remove"
              >
                ✕
              </button>

              <!-- Security Type -->
              <div class="relative z-0 w-full mb-5 group">
                <input
                  formControlName="securityType"
                  [ngClass]="{
                    'border-red-500': isBreakdownFieldInvalid(
                      i,
                      j,
                      'securityType'
                    )
                  }"
                  type="text"
                  [id]="'securityType' + i + j"
                  class="block py-2.5 px-0 w-full text-sm text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 appearance-none focus:outline-none focus:ring-0 focus:border-[#1f273b] peer"
                  placeholder=" "
                />
                <label
                  [for]="'securityType' + i + j"
                  class="peer-focus:font-medium absolute text-sm text-gray-500 duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:text-[#1f273b] peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6"
                >
                  Security Type
                </label>
                <small
                  *ngIf="isBreakdownFieldInvalid(i, j, 'securityType')"
                  class="text-red-500"
                >
                  {{ getBreakdownErrorMessage(i, j, "securityType") }}
                </small>
              </div>

              <!-- Transaction Type -->
              <div class="relative w-full mb-5 group">
                <p-dropdown
                  [options]="transactionTypeOptions"
                  optionLabel="label"
                  optionValue="value"
                  formControlName="transactionType"
                  [ngClass]="{
                    'ng-invalid ': isBreakdownFieldInvalid(
                      i,
                      j,
                      'transactionType'
                    )
                  }"
                  [panelStyleClass]="'z-[9999]'"
                  [style]="{
                    border: 'none',
                    paddingLeft: '0px',
                    paddingRight: '0px',
                    width: '100%',
                    fontSize: '0.875rem',
                    color: '#111827',
                    borderBottom: '2px solid #d1d5db',
                    boxShadow: 'none',
                    borderRadius: '0',
                    outline: 'none',
                    paddingTop: '9px',
                    paddingBottom: '9px'
                  }"
                  [inputId]="'transactionType' + i + j"
                  placeholder="Select Transaction Type"
                  class="w-full"
                ></p-dropdown>
                <label
                  [for]="'transactionType' + i + j"
                  class="peer-focus:font-medium absolute left-0 text-sm text-gray-500 duration-300 transform -translate-y-6 scale-75 top-3 origin-[0] peer-focus:text-[#1f273b] peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6"
                >
                  Transaction Type
                </label>
                <small
                  *ngIf="isBreakdownFieldInvalid(i, j, 'transactionType')"
                  class="text-red-500"
                >
                  {{ getBreakdownErrorMessage(i, j, "transactionType") }}
                </small>
              </div>
              <!-- Maximum Shares -->
              <div class="relative z-0 w-full mb-5 group">
                <input
                  formControlName="numberOfShares"
                  [ngClass]="{
                    'border-red-500': isBreakdownFieldInvalid(
                      i,
                      j,
                      'numberOfShares'
                    )
                  }"
                  type="number"
                  [id]="'numberOfShares' + i + j"
                  class="block py-2.5 px-0 w-full text-sm text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 appearance-none focus:outline-none focus:ring-0 focus:border-[#1f273b] peer"
                  placeholder=" "
                />
                <label
                  [for]="'numberOfShares' + i + j"
                  class="peer-focus:font-medium absolute text-sm text-gray-500 duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:text-[#1f273b] peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6"
                >
                  Number Of Shares
                </label>
                <small
                  *ngIf="isBreakdownFieldInvalid(i, j, 'numberOfShares')"
                  class="text-red-500"
                >
                  {{ getBreakdownErrorMessage(i, j, "numberOfShares") }}
                </small>
              </div>

              <!-- Aggregate Number Shares -->
              <div class="relative z-0 w-full mb-5 group">
                <textarea
                  formControlName="sharesDescription"
                  [ngClass]="{
                    'border-red-500': isBreakdownFieldInvalid(
                      i,
                      j,
                      'sharesDescription'
                    )
                  }"
                  rows="1"
                  [id]="'sharesDescription' + i + j"
                  class="block py-2.5 px-0 w-full text-sm text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 appearance-none focus:outline-none focus:ring-0 focus:border-[#1f273b] peer"
                  placeholder=" "
                ></textarea>
                <label
                  [for]="'sharesDescription' + i + j"
                  class="peer-focus:font-medium absolute text-sm text-gray-500 duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:text-[#1f273b] peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6"
                >
                  Shares Description
                </label>
                <small
                  *ngIf="isBreakdownFieldInvalid(i, j, 'sharesDescription')"
                  class="text-red-500"
                >
                  {{ getBreakdownErrorMessage(i, j, "sharesDescription") }}
                </small>
              </div>

              <!-- Notional Value -->
              <div class="relative z-0 w-full mb-5 group">
                <input
                  formControlName="notionalValue"
                  [ngClass]="{
                    'border-red-500': isBreakdownFieldInvalid(
                      i,
                      j,
                      'notionalValue'
                    )
                  }"
                  [id]="'notionalValue' + i + j"
                  class="block py-2.5 px-0 w-full text-sm text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 appearance-none focus:outline-none focus:ring-0 focus:border-[#1f273b] peer"
                  placeholder=" "
                />
                <label
                  [for]="'notionalValue' + i + j"
                  class="peer-focus:font-medium absolute text-sm text-gray-500 duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:text-[#1f273b] peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6"
                >
                  Notional Value
                </label>
                <small
                  *ngIf="isBreakdownFieldInvalid(i, j, 'notionalValue')"
                  class="text-red-500"
                >
                  {{ getBreakdownErrorMessage(i, j, "notionalValue") }}
                </small>
              </div>

              <!-- Trading Conditions -->
              <div class="relative z-0 w-full mb-5 group">
                <textarea
                  formControlName="tradingConditions"
                  rows="2"
                  [id]="'tradingConditions' + i + j"
                  class="block py-2.5 px-0 w-full text-sm text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 appearance-none focus:outline-none focus:ring-0 focus:border-[#1f273b] peer"
                  placeholder=" "
                ></textarea>
                <label
                  [for]="'tradingConditions' + i + j"
                  class="peer-focus:font-medium absolute text-sm text-gray-500 duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:text-[#1f273b] peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6"
                >
                  Trading Conditions
                </label>
              </div>

              <!-- Early Termination Conditions -->
              <div class="relative z-0 w-full mb-5 group">
                <textarea
                  formControlName="earlyTerminationConditions"
                  rows="2"
                  [id]="'earlyTerminationConditions' + i + j"
                  class="block py-2.5 px-0 w-full text-sm text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 appearance-none focus:outline-none focus:ring-0 focus:border-[#1f273b] peer"
                  placeholder=" "
                ></textarea>
                <label
                  [for]="'earlyTerminationConditions' + i + j"
                  class="peer-focus:font-medium absolute text-sm text-gray-500 duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:text-[#1f273b] peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6"
                >
                  Early Termination
                </label>
              </div>
              <!-- <div class="button-group flex items-center">
                <button
                  class="py-1 px-5 border border-[#d9d9d9] rounded text-gray-900 cursor-pointer hover:bg-[#2a334a] hover:text-white"
                  (click)="AddTags(i, j)"
                >
                  Tags
                </button>
              </div> -->

              <div class="button-group flex items-center mt-2">
                <button
                  (click)="AddTags(i, j)"
                  class="flex items-center cursor-pointer gap-2 py-2 px-4 border border-[#d1d5db] rounded-lg bg-white text-gray-700 hover:bg-[#1f273b] hover:text-white transition-all duration-200 shadow-sm hover:shadow-md focus:outline-none"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    class="w-4 h-4"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M7 7h.01M5 11a1 1 0 011-1h.01M11 5h2m2 2h.01M13 13h3l2-2m0 0l2 2m-2-2v6a2 2 0 01-2 2H7a2 2 0 01-2-2v-3"
                    />
                  </svg>
                  <span class="text-sm font-medium">Manage Tags</span>
                </button>
              </div>
            </div>
          </div>
        </div>
        <div *ngIf="showMessage" class="text-red-500 font-medium my-2">
          {{ messageText }}
        </div>
      </div>
    </div>
  </div>
  <!-- Terms and Conditions -->
  <div class="flex items-center mt-6">
    <input type="checkbox" formControlName="followUp" class="mr-2" />
    <label class="text-sm">Follow up comment</label>
  </div>

  <!-- Global Follow-up comment field -->
  <div
    class="relative z-0 w-full my-5 group"
    *ngIf="formMainGroup.get('followUp')?.value"
  >
    <textarea
      formControlName="followUpComment"
      rows="1"
      id="followUpComment"
      class="block py-2.5 px-0 w-full text-sm text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 appearance-none focus:outline-none focus:ring-0 focus:border-[#1f273b] peer"
      placeholder=" "
    ></textarea>
    <label
      for="followUpComment"
      class="peer-focus:font-medium absolute text-sm text-gray-500 duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:text-[#1f273b] peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6"
    >
      Follow Up Comment
    </label>
  </div>
  <div class="button-group flex justify-end">
    <button
      class="py-1 px-5 border border-[#d9d9d9] rounded bg-[#1f273b] text-white cursor-pointer hover:bg-[#2a334a]"
      (click)="validateForm()"
    >
      Update
    </button>
  </div>
</div>
